import ProductsEntry from './products-entry';
import ScrollMagic from 'scrollmagic';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

export default class ProductsEntryDesktop extends ProductsEntry {
	constructor(...args) {
		super(...args);

		this._initDom();
		this._initFixed();
	}

	_initDom() {
		this.dom.btn = this.dom.page.querySelector('.js-button-sticky');
		this.dom.header = this.dom.page.querySelector('.js-header');
		this.dom.technical = this.dom.page.querySelector('.js-technical');
		
		this.dom.btn.style.width = this.dom.btn.offsetWidth + 'px';
	}

	_initFixed() {
		this.Controller = new ScrollMagic.Controller();
		this.Scene = new ScrollMagic.Scene({triggerElement: this.dom.btn, duration: this.dom.technical.offsetHeight})
			.setPin(this.dom.btn)
			.addTo(this.Controller);
	}

	/**
	 * init() {}
	 * bind() {}
	 * unbind() {}
	 * resize(width, height) {}
	 * _destroy() {}
	 */
}



// WEBPACK FOOTER //
// ./src/js/pages/products/entry/products-entry.desktop.js